import React from 'react';
import Lang from '../../../components/language/services/Lang';
import HrbTranslate from '../../../components/language/HrbTranslate';

const QuickLinks = () => {
    return (
        <div className='columns'>
            <div className='column is-1' />
            <div className='column is-4'>
                <a href={Lang.getCurrentValue('Links.Urls.CRA')} target='_blank' rel='noopener noreferrer'>
                    <HrbTranslate text='Links.Labels.CRA' />
                </a>
            </div>
            <div className='column is-4'>
                <a href={Lang.getCurrentValue('Links.Urls.RQ')} target='_blank' rel='noopener noreferrer'>
                    <HrbTranslate text='Links.Labels.RQ' />
                </a>
            </div>
            <div className='column is-5' />
        </div>
    )
}

export default QuickLinks;
